import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";
export const getInvoiceTableCol=(filteredInfos)=> {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '负责人',
            key: 'principal',
            scopedSlots: {
                customRender: 'principal'
            }
        },
        {
            title: '开票单位',
            dataIndex: 'billingUnit.companyName',
            key: 'billingUnit'
        },
        {
            title: '发票抬头',
            dataIndex: 'invoiceTitle',
            key: 'invoiceTitle'
        },
        {
            title: '发票类型',
            dataIndex: 'invoiceType',
            key: 'invoiceType',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.invoiceType|| [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '发票金额',
            dataIndex: 'invoiceAmount',
            key: 'invoiceAmount'
        },{
            title: '发票内容',
            dataIndex: 'invoiceContent',
            key: 'invoiceContent'
        }
        ,{
            title: '备注',
            dataIndex: 'remark',
            key: 'remark'
        },
    ]
}
